import { CountryEnv } from "@type/country";

const _countryEnv: CountryEnv = {
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_JP_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_JP_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_JP_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_JP_UQ || "",
  faqUrl: "https://faq.global.com/"
};

export default _countryEnv;
